// extracted by mini-css-extract-plugin
export default {"iconMenuBtn":"RefreshOddania_iconMenuBtn__ew2jR","iconMenuBtnDisabled":"RefreshOddania_iconMenuBtnDisabled__onPKY"};